import { useNavigate, Link, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

export function StudioLayout({ children, brand, active }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-app">
      <header className="sticky top-0 z-30 bg-app/95 backdrop-blur border-b border-line no-print">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-14 flex items-center gap-4">
          <Link to="/" data-testid="logo-home" className="flex items-center">
            <img src="/studio83-logo.png" alt="Studio 83" className="h-4 w-auto" style={{ filter: "brightness(0)" }} />
          </Link>
          {brand && (
            <>
              <span className="text-line">/</span>
              <Link to="/" data-testid="breadcrumb-brands" className="text-sm text-subtle hover:text-ink">Marcas</Link>
              <span className="text-line">/</span>
              <Link to={`/brand/${brand.id}`} data-testid="breadcrumb-brand" className="flex items-center gap-2 text-sm hover:opacity-70">
                <span style={{ width: 8, height: 8, background: brand.color, borderRadius: "50%" }} data-testid="active-brand-dot" />
                <span className="font-medium">{brand.name}</span>
              </Link>
            </>
          )}
          <div className="ml-auto flex items-center gap-4 text-sm">
            <span className="text-subtle hidden sm:inline">{user?.name}</span>
            <button onClick={() => { logout(); navigate("/login"); }} data-testid="logout-btn" className="text-subtle hover:text-ink flex items-center gap-1.5">
              <LogOut size={15} strokeWidth={1.5} /> Salir
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-[1400px] mx-auto px-5 sm:px-8 py-8">{children}</main>
    </div>
  );
}
